module.exports = __webpack_public_path__ + "img/全国销售毛利额(元).228a27c6.png";